import { render } from "./BajaTable.vue?vue&type=template&id=486a30d4"
import script from "./BajaTable.vue?vue&type=script&lang=js"
export * from "./BajaTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__